import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import "../index.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


const Booking = () => {
  const [bookings, setBookings] = useState([]);
  const [profile, setProfile] = useState(null);
  const navigate = useNavigate();

  // ⭐ Load logged-in user & redirect if not logged in
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (!storedUser) {
      navigate("/login", { state: { from: "/booking" } });
      return;
    }

    const userData = JSON.parse(storedUser);
    setProfile(userData);
  }, [navigate]);

  // ⭐ Toggle Active / Cancel
  const toggleStatus = async (bookingId) => {
  try {
    const response = await fetch(
      "https://online.funforay.com/admin/api/booking/toggle-user-action",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          booking_id: bookingId,
          user_id: profile?.id,
        }),
      }
    );

    const data = await response.json();

    if (data.success) {
      alert(
        "Status: " + data.new_status +
        "\nRemaining Attempts: " + data.remaining_attempts +
        "\nTime Left: " + data.hours_remaining + " hours"
      );

      fetchBookings(); // reload
    } else {
      alert(data.message);
    }
  } catch (err) {
    console.error(err);
  }
};
const isToggleDisabled = (booking) => {
  // If backend sends remaining_attempts and hours_remaining
  if (booking.remaining_attempts !== undefined && booking.hours_remaining !== undefined) {
     return booking.remaining_attempts <= 0 || booking.hours_remaining <= 0;
  }

  // Fallback: calculate from created_at
  const createdAt = new Date(booking.created_at);
  const now = new Date();
  const diffHours = (now - createdAt) / (1000 * 60 * 60);

  return diffHours > 24;
};

  // ⭐ Fetch bookings of logged in user
  const fetchBookings = () => {
    if (!profile) return;

    fetch("https://online.funforay.com/admin/api/user-bookings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: profile.id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setBookings(data.data || []);
      })
      .catch((err) => console.log("Error fetching bookings:", err));
  };

  useEffect(() => {
    fetchBookings();
  }, [profile]);

  // ⭐ Status Mapping
  const statusMap = {
    "0": { text: "Pending", bg: "#FFC107", color: "#000" },
    "1": { text: "Accepted", bg: "#118a58", color: "#fff" },
    "2": { text: "Rejected", bg: "#dc3545", color: "#fff" },
    "3": { text: "Booked", bg: "#0d6efd", color: "#fff" },
    "4": { text: "Vouchered", bg: "#6f42c1", color: "#fff" },
  };

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <div className="responsive_forsidebar">
        <Sidebar />
      </div>

      {/* Main Content */}
      <div style={{ flexGrow: 1, overflowY: "auto", padding: "25px" }}>
        <h2 style={{ marginBottom: "20px" }}>My Bookings</h2>

        <div className="booking-container">
          {bookings.length > 0 ? (
            <table className="booking-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Booking Id</th>
                  <th>Package</th>
                  <th>Price</th>
                  <th>Hotel Rating</th>
                  <th>Rooms</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>User Action</th>
                </tr>
              </thead>

              <tbody>
                {bookings.map((b, index) => {
                  const s = statusMap[String(b.status)];

                  return (
                    <tr key={b.id}>
                      <td>{index + 1}</td>
                      <td>{b.booking_id}</td>
                      <td>
                        <Link
                          to={`/packages/${b.package_id}`}
                          style={{
                            color: "#0d6efd",
                            textDecoration: "none",
                            fontWeight: "600",
                          }}
                        >
                          {b.package_name}
                        </Link>
                      </td>

                      <td>₹{b.package_price}</td>

                      {/* Hotel Rating */}
                      <td>
                        {Array.from({ length: b.hotel_rating }, (_, i) => (
                          <span
                            key={i}
                            style={{ color: "#fbc02d", fontSize: "18px" }}
                          >
                            ★
                          </span>
                        ))}
                      </td>

                      {/* Rooms */}
                      <td>
                        {Array.isArray(b.rooms) && b.rooms.length > 0 ? (
                          <table>
                            <thead>
                              <tr style={{ background: "#f7f7f7" }}>
                                <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                  Room Type
                                </th>
                                <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                  Adults
                                </th>
                                <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                  CWB
                                </th>
                                <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                  CNB
                                </th>
                                <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                  Infant
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {b.rooms.map((room, index) => (
                                <tr key={index}>
                                  <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    {room.room_type}
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    {room.adults}
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    {room.cwb}
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    {room.cnb}
                                  </td>
                                  <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    {room.infant}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          "No room details"
                        )}
                      </td>

                      <td>{b.booking_from}</td>

                      {/* Status */}
                      <td>
                        <span
                          style={{
                            background: s.bg,
                            padding: "6px 18px",
                            borderRadius: "25px",
                            color: s.color,
                            fontWeight: "600",
                            fontSize: "14px",
                            display: "inline-block",
                          }}
                        >
                          {s.text}
                        </span>
                      </td>

                      {/* User Action */}
                    <td>
  <button
    className="btn user_action"
    onClick={() => toggleStatus(b.id)}
    disabled={isToggleDisabled(b)}
    style={{
      backgroundColor: isToggleDisabled(b) ? "#ccc" : "#28a745",
      cursor: isToggleDisabled(b) ? "not-allowed" : "pointer",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
    }}
  >
    {isToggleDisabled(b)
      ? "Locked"
      : b.user_action === "active"
      ? "Cancel"
      : "Activate"}
  </button>

  
</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No bookings found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Booking;
